/** Prefixed to the field label so the toggle's accessible name tracks label copy edits for free. */
export const HINT_TOGGLE_LABEL_PREFIX = 'About';
